export default {
    "🤬": {
        "small": "emojis\/emoji-angry-25x25.png",
        "medium": "emojis\/emoji-angry-80x80.png",
        "large": "emojis\/emoji-angry-240x240.png"
    },
    "😡": {
        "small": "emojis\/emoji-angry-25x25.png",
        "medium": "emojis\/emoji-angry-80x80.png",
        "large": "emojis\/emoji-angry-240x240.png"
    },
    "🙄": {
        "small": "emojis\/emoji-confused-25x25.png",
        "medium": "emojis\/emoji-confused-80x80.png",
        "large": "emojis\/emoji-confused-240x240.png"
    },
    "😊": {
        "small": "emojis\/emoji-happy-25x25.png",
        "medium": "emojis\/emoji-happy-80x80.png",
        "large": "emojis\/emoji-happy-240x240.png"
    },
    "🙂": {
        "small": "emojis\/emoji-happy-25x25.png",
        "medium": "emojis\/emoji-happy-80x80.png",
        "large": "emojis\/emoji-happy-240x240.png"
    },
    "😝": {
        "small": "emojis\/emoji-laugh-25x25.png",
        "medium": "emojis\/emoji-laugh-80x80.png",
        "large": "emojis\/emoji-laugh-240x240.png"
    },
    "😍": {
        "small": "emojis\/emoji-loveeyes-25x25.png",
        "medium": "emojis\/emoji-loveeyes-80x80.png",
        "large": "emojis\/emoji-loveeyes-240x240.png"
    },
    "😞": {
        "small": "emojis\/emoji-sad-25x25.png",
        "medium": "emojis\/emoji-sad-80x80.png",
        "large": "emojis\/emoji-sad-240x240.png"
    },
    "😢": {
        "small": "emojis\/emoji-sad-25x25.png",
        "medium": "emojis\/emoji-sad-80x80.png",
        "large": "emojis\/emoji-sad-240x240.png"
    },
    "😔": {
        "small": "emojis\/emoji-sleepy-25x25.png",
        "medium": "emojis\/emoji-sleepy-80x80.png",
        "large": "emojis\/emoji-sleepy-240x240.png"
    },
    "😮": {
        "small": "emojis\/emoji-suprised-25x25.png",
        "medium": "emojis\/emoji-suprised-80x80.png"
    },
    "👎": {
        "small": "emojis\/emoji-thumbsdown-25x25.png",
        "medium": "emojis\/emoji-thumbsdown80x80.png",
        "large": "emojis\/emoji-thumbsdown-240x240.png"
    },
    "👍": {
        "small": "emojis\/emoji-thumbsup-25x25.png",
        "medium": "emojis\/emoji-thumbsup-80x80.png",
        "large": "emojis\/emoji-thumbsup-240x240.png"
    },
    "😕": {
        "small": "emojis\/emoji-worried-25x25.png",
        "medium": "emojis\/emoji-worried-80x80.png",
        "large": "emojis\/emoji-worried-240x240.png"
    },
    "🙁": {
        "small": "emojis\/emoji-worried-25x25.png",
        "medium": "emojis\/emoji-worried-80x80.png",
        "large": "emojis\/emoji-worried-240x240.png"
    },
    "💰": {
        "small": "emojis\/emoji-dollars-25x25.png",
        "medium": "emojis\/emoji-dollars-80x80.png",
        "large": "emojis\/emoji-dollars-240x240.png"
    },
    "💬": {
        "small": "emojis\/emoji-speak-25x25.png",
        "medium": "emojis\/emoji-speak-80x80.png",
        "large": "emojis\/emoji-speak-240x240.png"
    },
    "🖊️": {
        "small": "emojis\/emoji-write-25x25.png",
        "medium": "emojis\/emoji-write-80x80.png",
        "large": "emojis\/emoji-write-240x240.png"
    },
    "🛑": {
        "small": "emojis\/emoji-stop-25x25.png",
        "medium": "emojis\/emoji-stop-80x80.png",
        "large": "emojis\/emoji-stop-240x240.png"
    },
    "❌": {
        "small": "emojis\/emoji-close-icon-25x25.png",
        "medium": "emojis\/emoji-close-icon-80x80.png",
        "large": "emojis\/emoji-close-icon-240x240.png"
    },
    "👆": {
        "small": "emojis\/emoji-hand-25x25.png",
        "medium": "emojis\/emoji-hand-80x80.png",
        "large": "emojis\/emoji-hand-240x240.png"
    },
    "🔍": {
        "small": "emojis\/emoji-magnifying-glass-25x25.png",
        "medium": "emojis\/emoji-magnifying-glass-80x80.png",
        "large": "emojis\/emoji-magnifying-glass-240x240.png"
    },
    "🤷‍♀️": {
        "small": "emojis\/emoji-shrugging-25x25.png",
        "medium": "emojis\/emoji-shrugging-80x80.png",
        "large": "emojis\/emoji-shrugging-240x240.png"
    },
    "🤗": {
        "small": "emojis\/emoji-happy-25x25.png",
        "medium": "emojis\/emoji-happy-80x80.png",
        "large": "emojis\/emoji-happy-240x240.png"
    },
    "🤔": {
        "small": "emojis\/emoji-natural-25x25.png",
        "medium": "emojis\/emoji-natural-80x80.png",
        "large": "emojis\/emoji-natural-240x240.png"
    }
}